// extracted by mini-css-extract-plugin
module.exports = {"Sidebar":"_2o39kvEE","Content":"_1g_xfll4","right":"_2v_AVwpy","Layout":"nwoelMsO"};
    if(module.hot) {
      // 1746735810680
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  